import styled from 'styled-components';

export const AlertView = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-radius: 3px;
  padding: 16px;
  border: 1px solid ${({ theme }) => theme.colors.statusRed};
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: ${({ theme }) => theme.colors.statusRed};
    opacity: 0.1;
  }
`;

export const AlertTitleContainer = styled.div`
  display: flex;
  gap: 8px;
  color: ${({ theme }) => theme.colors.statusRed};
`;
